import { useEffect } from 'react'
import Navigation from '@/components/Navigation'
import { Link } from 'wouter'
import { usePageMeta } from '@/hooks/usePageMeta'

const GetInTouchPage = () => {
  usePageMeta({
    title: 'Get In Touch | SPOKE Film',
    description: "Connect with the SPOKE film team. Don't miss your chance to make a difference for firefighter health and wellness.",
  })
  useEffect(() => {
    const existing = document.querySelector('script[src="https://static.elfsight.com/platform/platform.js"]')
    if (!existing) {
      const script = document.createElement('script')
      script.src = 'https://static.elfsight.com/platform/platform.js'
      script.async = true
      document.head.appendChild(script)
    }
  }, [])

  return (
    <div className="min-h-screen bg-[#0a0f1a] text-white">
      <Navigation />

      {/* Hero header */}
      <section className="relative min-h-[38vh] bg-[#0a0f1a] flex items-end pt-24 pb-16 px-6">
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 to-[#0a0f1a]"></div>
        <div className="relative z-10 max-w-5xl mx-auto w-full text-center">
          <div className="w-12 h-1 bg-red-600 mb-6 mx-auto"></div>
          <h1 className="text-5xl md:text-7xl font-montserrat font-black uppercase tracking-wide text-white leading-none">
            Get In Touch
          </h1>
          <p className="mt-4 text-yellow-400 font-poppins font-light text-lg">
            Don't miss your chance to make a difference!
          </p>
        </div>
      </section>

      <div className="pb-20 px-6">
        <div className="max-w-6xl mx-auto">

          <div className="flex flex-col lg:flex-row lg:gap-8 lg:items-center">

            {/* Left — SPOKE poster */}
            <div className="flex flex-col items-center lg:w-72 lg:flex-shrink-0 mb-6 lg:mb-0 lg:pl-20">
              <img
                src="/spoke-static/images/spoke-poster-final.jpg"
                alt="SPOKE official poster"
                className="w-64 lg:w-80 rounded-lg"
                loading="lazy"
                decoding="async"
              />
            </div>

            {/* Right — Elfsight form */}
            <div className="flex-1 min-w-0">
              <div className="elfsight-app-836151d1-a8d2-4dfe-a5df-1de1582d2a40" data-elfsight-app-lazy></div>
            </div>

          </div>

          {/* Back link */}
          <div className="text-center mt-12">
            <Link
              href="/"
              className="font-poppins text-sm text-gray-500 hover:text-white transition-colors tracking-wide underline"
            >
              ← Back to SPOKE
            </Link>
          </div>

        </div>
      </div>
    </div>
  )
}

export default GetInTouchPage
